import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@components/Button/Button";
import { useNotification } from "@context/NotificationContext";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation";
import { checkPermission } from "@utils/user-permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface AddPortServiceButtonProps {
  langBase: string;
  hasRestrictedVesselCallStatus: boolean;
}

const AddPortServiceButton = ({
  langBase,
  hasRestrictedVesselCallStatus,
}: AddPortServiceButtonProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { notify } = useNotification();
  const { userActionPermissions } = useAuthStore();

  const handleClick = () => {
    if (hasRestrictedVesselCallStatus) {
      notify({
        title: t(`${langBase}.notifications.service-actions-not-allowed`),
        type: "error",
      });
      return;
    }

    navigate(`${paths.vesselCall.addPortService}`);
  };

  return checkPermission(userActionPermissions, "canRequestPortService") ? (
    <Button
      type="button"
      variant="contained"
      color="primary"
      testId={`${langBase}-create-button`}
      label={
        <span className="text-sm font-medium flex items-center gap-2">
          <AddCircleOutlineIcon fontSize="small" />
          {t(`${langBase}.add-service`)}
        </span>
      }
      sx={{
        textTransform: "none",
        height: "40px",
        minHeight: "40px",
      }}
      onClick={handleClick}
    />
  ) : null;
};
export default AddPortServiceButton;
